import React, { Fragment } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

import Bar from './Bar'
import ContenHeader from 'components/ContenHeader'
import { NavBarContent } from './styled'


const StyledNavBar = styled.div`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	height: 100%;
`

const StyledLabelInfo = styled.span`
	font-size: 14px;
	color: ${({ theme }) => theme.errorColor};
	&:first-of-type {
		margin-left: 24px;
	}
`

const NavBar = ({ barHeight, children, isContentLoading, className, id, label, labelInfo, headerComponents, ...barProps }) => {
	const composedLabel = (
		<Fragment>
			{label}
			{Array.isArray(labelInfo) && labelInfo.map((item, i, arr) => <StyledLabelInfo key={i}>{item}{i + 1 !== arr.length && ', '}</StyledLabelInfo>)}
		</Fragment>
	)
	return(
		<StyledNavBar id={id} className={className}>
			{(label || label === '' || headerComponents) &&
				<ContenHeader
					title={composedLabel}
					{...headerComponents && { rightCol: headerComponents }}
				/>
			}
			<Bar height={barHeight} {...barProps}/>
			<NavBarContent className='NavBar-content' isLoading={isContentLoading}>
				{children}
			</NavBarContent>
		</StyledNavBar>
	)
}

NavBar.propTypes = {
	// Number in px or styled theme.navBarHeight[barHeight] in case of string will be used for css height of <Bar />
	barHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
	navContent: PropTypes.arrayOf(PropTypes.shape({
		Component: PropTypes.elementType,
		name: PropTypes.string,
		icon: PropTypes.elementType,
		style: PropTypes.object,
		className: PropTypes.string,
		active: PropTypes.bool,
		hideInNav: PropTypes.bool
	})).isRequired,
	label: PropTypes.string,
	labelInfo: PropTypes.array,
	getLink: PropTypes.func,
	headerComponents: PropTypes.node
}

export default NavBar
